import { TimeEntryGridConfigModel } from "app/core/mips/common/models/time-entry-grid-config.model";

export interface TimeEntryGridConfig {
    timeEntryGridConfig: TimeEntryGridConfigModel | null;
}

export const initialTimeEntryGridConfigModel: TimeEntryGridConfig = {
    timeEntryGridConfig: null
};
  